module.exports = __webpack_public_path__ + "static/media/Potregi.d86b8e07.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Potregi.ttf
// module id = 3439
// module chunks = 71